export default __webpack_public_path__ + "static/media/google-color.675d5ba4.svg";